// import { Carousel } from "bootstrap";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import "./Header.css";
// import CarouselPage from "../Carousel/CarouselPage";
// import img1 from "../../assets/image.png";
// import img2 from "../../assets/homeimg1.jpg";
// import img3 from "../../assets/homeimg2.jpg";


const HeaderSection = ({ image, imageStyle }) => {
  const navigate = useNavigate();
 

  return (
    <div className="home-container">
    <div className="image-container">
      <img src={image} alt="home" 
      className="home-image image-hide img-fix"
      style={imageStyle} />
      {/* <CarouselPage images={carouselImages} /> */}
      <div className="repeated-text">
        <p className="repeated-para">BRINGING SMILES THROUGH EDUCATION AND EMPOWERMENT ✦</p>
        <p className="repeated-para">BRINGING SMILES THROUGH EDUCATION AND EMPOWERMENT ✦</p>
        <p>BRINGING SMILES THROUGH EDUCATION AND EMPOWERMENT ✦</p>
      </div>
    </div>
    <div className="info-section hide-on-mobile">
      <div className="container">
        <div className="membership">
          <span>Click here to</span> <br />
          <Link to="/membership" className="membership-link">

            Apply for the <strong>Membership</strong>
          </Link>
        </div>
        <button className="donate-button" onClick={() => navigate('/donate-form')} >Donate</button>
        <div className="lives-saved">
          <span className="big-text">10,000+</span> <br />
          <span className="small-text">Lives Saved</span>
        </div>
      </div>
    </div>
    <div className="content">
      <p>
        <strong>
          E-techno aims to foster unity, brotherhood, and harmony within the
          public
        </strong>
        , promoting national integration and opposing separatist forces in
        India. It intends to establish educational institutions, including
        digital and AI learning centers, boarding schools, paramedical and
        medical colleges, technical institutes, and vocational training centers
        across various regions.
      </p>
      <p>
        <strong>
          E-techno acts as a catalyst in the cycle of change, complementing and
          supporting non-profit efforts
        </strong>{" "}
        to achieve Sustainable Development Goals. We collaborate with
        like-minded institutions and individuals to implement high-impact
        programs that improve access, enhance quality, and bring about
        long-term behavioral change at the grassroots level for children.
      </p>
      <p>
        <strong>We have recently launched a Membership Program</strong> to
        enable our Fellows to live and work with us in any location, helping
        them contribute to and benefit the community.
      </p>
   </div>
      <div className="vision-container">
      <h1 className="vision-title">OUR VISION</h1>
      <p className="vision-text">
        “A happy, healthy, and creative child whose rights are protected and
        honoured in a society that is built on respect for dignity, justice,
        and equity for all.”
      </p>
    </div>
  </div>
  );
};

export default HeaderSection;
